/* angular:styles/component:css;372984788218438693ac5cc9691844cc75722e519feaa5f76fd8dd955132f44e;/src/src/app/edge/live/common/storage/admin-modal/admin-modal.component.ts */
.ess-accordion-group {
  padding: 0 0.625rem;
}
.ess-accordion {
  margin: 1rem 0;
  border-radius: 0.625rem;
  overflow: hidden;
  width: 100%;
}
.ess-accordion-header {
  --background: var(--ion-color-light);
  --color: var(--ion-color-title);
  --padding-start: 0.75rem;
  --inner-padding-end: 0.75rem;
  --min-height: 2.75rem;
  --border-color: transparent;
  box-shadow: 0 0.125rem 0.375rem var(--ion-card-header-shadow);
}
.ess-accordion-content {
  background: var(--ion-color-light);
}
/*# sourceMappingURL=admin-modal.component.css.map */
